import { defineMessage } from 'services/localization';

export const messages = {
    openInRbLinkText: defineMessage('open_the_original_document'),
};
